import { checkIfErrorCodePresent } from '../utils/errorHandling';

import { NUMBER_IS_LOCKED } from '../reducers/numbers';

export const customErrorMessage = ({ dispatch, getState }) => {
  return next => action => {
    if (numberIsLocked(action)) {
      dispatch({ type: NUMBER_IS_LOCKED });
      return;
    }

    return next(action);
  };
};

const numberIsLocked = action => {
  if (action.error) {
    const errorCode = 'update_or_deletion_of_restricted_number_failed';
    return checkIfErrorCodePresent(action.error, errorCode);
  }

  return false;
};
